import { useAdminCampaignPurchases, PURCHASES_PER_PAGE } from "@/hooks/useAdminCampaignPurchases";
import CampaignPurchasesFilter from "./CampaignPurchasesFilter";
import CampaignPurchasesTable from "./CampaignPurchasesTable";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronLeft, ChevronRight, ShoppingCart } from "lucide-react";

const CampaignPurchasesList = () => {
  const {
    purchases,
    isLoading,
    isEmpty,
    // Tag-based filters
    filterTags,
    addFilter,
    removeFilter,
    clearAllFilters,
    // Pagination
    currentPage,
    setCurrentPage,
    totalPages,
    totalPurchases,
    // Sorting
    sortField,
    sortDirection,
    handleSort,
  } = useAdminCampaignPurchases();

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between gap-4">
          <div>
            <CardTitle className="flex items-center gap-2">
              <ShoppingCart className="h-5 w-5 text-secondary" />
              Purchases Management
            </CardTitle>
            <CardDescription>
              View and filter campaign package purchases
            </CardDescription>
          </div>
          <CampaignPurchasesFilter
            filterTags={filterTags}
            onAddFilter={addFilter}
            onRemoveFilter={removeFilter}
            onClearAllFilters={clearAllFilters}
          />
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="rounded-md border overflow-x-auto">
          <CampaignPurchasesTable
            purchases={purchases}
            isLoading={isLoading}
            isEmpty={isEmpty}
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={handleSort}
          />
        </div>
        
        {totalPurchases > 0 && (
          <div className="flex items-center justify-between mt-3">
            <p className="text-sm text-muted-foreground">
              {totalPages > 1 
                ? `Showing ${(currentPage - 1) * PURCHASES_PER_PAGE + 1} to ${Math.min(currentPage * PURCHASES_PER_PAGE, totalPurchases)} of ${totalPurchases} purchases`
                : `Showing ${totalPurchases} purchases of ${totalPurchases}`
              }
            </p>
            {totalPages > 1 && (
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft className="h-4 w-4" />
                  Previous
                </Button>
                <span className="text-sm text-muted-foreground">
                  Page {currentPage} of {totalPages}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                >
                  Next
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CampaignPurchasesList;
